import React, { useState } from 'react';
import cn from 'classnames';
import Select from 'react-select';
import NewFeature from '../index';

const GroupSelect = ({
  title,
  placeholder,
  className,
  fields,
  state,
  path,
  disabled,
  handleChange,
  handleGroupSelectChange,
  handleSettingsModification,
  currentLandingSettingsOverrides,
}) => {
  const [selected, setSelected] = useState(() => {
    let foundKey = Object.keys(state)
      .find((k) => k.includes(path))
      ?.split('/');
    let foundValue = foundKey && foundKey[foundKey.length - 1];
    return foundValue ?? null;
  });

  const handleSelectChange = (path, value) => {
    handleGroupSelectChange(path);
    setSelected(value);
  };

  return (
    <>
      {title ? <label className="features-control-label">{title}</label> : null}
      <Select
        placeholder={placeholder ?? title}
        className={cn('features-control', 'features-control--select', 'Select--sm', className)}
        clearable={false}
        options={fields.map((f) => ({ value: f.id, label: f.title }))}
        onChange={(v) => handleSelectChange(path, v.value)}
        value={selected}
        disabled={disabled}
      />
      {fields
        .filter((f) => f.id == selected)
        .map((el) => (
          <NewFeature
            key={el.title}
            {...el}
            handleChange={handleChange}
            stateOfThings={state}
            parentPath={path}
            handleSettingsModification={handleSettingsModification}
            currentLandingSettingsOverrides={currentLandingSettingsOverrides}
            title=""
            className="mt-2"
          />
        ))}
    </>
  );
};

export { GroupSelect };
